'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactI18next = require('react-i18next');

var _ExpireDateField = require('./ExpireDateField');

var _ExpireDateField2 = _interopRequireDefault(_ExpireDateField);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ExpireDateRow = (_dec = (0, _reactI18next.translate)(['common']), _dec(_class = (_temp = _class2 = function (_PureComponent) {
  (0, _inherits3.default)(ExpireDateRow, _PureComponent);

  function ExpireDateRow() {
    (0, _classCallCheck3.default)(this, ExpireDateRow);
    return (0, _possibleConstructorReturn3.default)(this, (ExpireDateRow.__proto__ || (0, _getPrototypeOf2.default)(ExpireDateRow)).apply(this, arguments));
  }

  (0, _createClass3.default)(ExpireDateRow, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          t = _props.t,
          className = _props.className,
          inputProps = _props.inputProps;


      return _react2.default.createElement(
        'div',
        { className: (0, _classnames2.default)('formRow wide simple', className) },
        _react2.default.createElement(
          'div',
          null,
          t('Expire Date'),
          '*'
        ),
        _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(_ExpireDateField2.default, { inputProps: inputProps })
        )
      );
    }
  }]);
  return ExpireDateRow;
}(_react.PureComponent), _class2.propTypes = {
  className: _propTypes2.default.string,
  inputProps: _propTypes2.default.object,
  t: _propTypes2.default.func
}, _class2.defaultProps = {
  inputProps: {}
}, _temp)) || _class);
exports.default = ExpireDateRow;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/QuickSend/form/ExpireDateRow.js
// module id = 839
// module chunks = 1